















































import VueOptions from '@utils/VueOptions'
import Back from '@modules/ui/buttons/Back'

settings =
  name: "CampaignShow"

  resources:
    campaign:
      resourceName: "campaign"
      slug: "campaigns/:campaignId"
      fetch: false

    cart:
      resourceName: 'shopping_cart'
      slug: 'campaigns/:campaignId/shopping_cart'
      fetch: false

  vue:
    props: ['campaignId']
    components: { Back }

    computed:
      activeRouteIsOverview: -> @$route.name is 'CampaignOverviewStage'
      activeRouteIsEventFeed: -> @$route.name is 'CampaignEventFeedStage'
      activeRouteIsCheckout: -> @$route.name is 'CampaignCheckoutStage'
      activeRouteIsSchedule: -> @$route.name is 'CampaignScheduleStage'
      summary: -> @cart?.summary || {}
      upcomingOfferCount: -> @ctxStats(@campaign, "offer").upcoming_count

    methods:
      onCollectionUnloadItemCompleted: (event) -> @$router.push({ name: 'CampaignListPage' })

export default VueOptions.vue settings
